// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"dea298d8","247":"8fb1e73f","453":"4233ac17","821":"05229f6f","896":"e013f5e1"}[chunkId] + ".chunk.js";
};